import script from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=52f62324&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f62324"]])

export default __exports__